// Lazy-load Mermaid and render any <code class="language-mermaid"> blocks.
let mermaidPromise: Promise<typeof import("mermaid")> | null = null;
let counter = 0;

async function loadMermaid() {
  if (!mermaidPromise) {
    mermaidPromise = (async () => {
      const mod = await import("mermaid");
      const isDark = document.documentElement.dataset.theme === "dark";
      mod.default.initialize({
        startOnLoad: false,
        theme: isDark ? "dark" : "default",
        securityLevel: "strict",
      });
      return mod;
    })();
  }
  return mermaidPromise;
}

export async function renderMermaidIn(root: HTMLElement): Promise<void> {
  const blocks = root.querySelectorAll<HTMLElement>("pre > code.language-mermaid, pre > code.lang-mermaid");
  if (blocks.length === 0) return;
  const mermaid = (await loadMermaid()).default;
  await Promise.all(Array.from(blocks).map(async (code) => {
    const pre = code.parentElement;
    if (!pre) return;
    const src = code.textContent ?? "";
    const id = `mermaid-${++counter}`;
    try {
      const { svg } = await mermaid.render(id, src);
      const wrap = document.createElement("div");
      wrap.className = "mermaid";
      wrap.innerHTML = svg;
      pre.replaceWith(wrap);
    } catch (err) {
      const fallback = document.createElement("div");
      fallback.className = "mermaid mermaid-error";
      fallback.textContent = `[mermaid error] ${(err as Error).message}`;
      pre.replaceWith(fallback);
    }
  }));
}
